export default __webpack_public_path__ + "407bf0a759ae46cea6128a0aef56ad50.svg";